import Model from '../Model';

// Abstract Gene model
// see sub-models for more specific examples
export default Model.extend({

});
